import React from 'react';
import { Modal } from 'antd';
import DataService from '../../lib/DataService';

export default class ArchiveChooseTemplateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      template: props.template,
      showModal: props.showModal,
      isChoose: props.isChoose,
      forParent: false,
      author: props.author,
    }

    this.chooseForParent = this.chooseForParent.bind(this);
    this.chooseTemplate = this.chooseTemplate.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      template: newProps.template,
      showModal: newProps.showModal,
      forParent: newProps.showModal ? this.state.forParent : false,
      author: newProps.author,
    })
  }

  chooseForParent() {
    this.setState({
      forParent: !this.state.forParent
    })
  }

  chooseTemplate() {
    this.props.callBack(this.state.template.id, this.state.forParent);
  }

  render() {
    return (
      <Modal
        className="archive-choose-template-page-modal"
        footer={null}
        title={null}
        onCancel={this.props.hideModal}
        visible={this.state.showModal}
      >
        <img className="template-img" src={this.state.template.exhibit_image} />
        {!this.state.isChoose && this.state.author == 'parent' && <div className="for-parent-text">此模版为家长填写</div>}
        {this.state.template.need_review && <div className="review">此模版填写的内容需经过管理员审核</div>}
        {this.state.isChoose &&
          <div className="btn-group">
            <div className={this.state.forParent ? "for-parent true" : "for-parent false"} onClick={this.chooseForParent}><span></span>此模版为家长填写</div>
            <div className="confirm" onClick={this.chooseTemplate}>确认选择</div>
          </div>
        }
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/ArchiveChooseTemplateModal.jsx